var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.modelvalue,
        expression: "modelvalue",
      },
    ],
    attrs: { autocomplete: !_vm.autocomplete },
    domProps: { value: _vm.modelvalue },
    on: {
      keypress: _vm._refreshList,
      keyup: [
        function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft",
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 0) {
            return null
          }
          return _vm._refreshList.apply(null, arguments)
        },
        function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "right", 39, $event.key, [
              "Right",
              "ArrowRight",
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 2) {
            return null
          }
          return _vm._refreshList.apply(null, arguments)
        },
      ],
      click: _vm._refreshList,
      input: function ($event) {
        if ($event.target.composing) {
          return
        }
        _vm.modelvalue = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }